let debounceTimeout;
function updateFreeShipping() {
  const freeShippingThreshold = 15;
  const giftThresholds = [
    { items: 7, gifts: 1 },
    { items: 12, gifts: 3 },
  ];

  function getGiftCount(quantity) {
    let giftCount = 0;
    giftThresholds.forEach((threshold) => {
      if (quantity >= threshold.items) {
        giftCount = threshold.gifts;
      }
    });
    return giftCount;
  }

  function updateFreeShippingBar() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        let totalQuantity = 0;
        let hasDiscountedProduct = false;
        const freeShippingBar = document.getElementById("free-shipping-bar");

        // ✅ If cart is empty, hide the bar immediately
        if (!cart.items.length) {
          if (freeShippingBar) freeShippingBar.style.display = "none";
          return;
        }

        // ✅ Loop through cart items and fetch product details
        const productChecks = cart.items.map((item) => {
          return fetch(`/products/${item.handle}.json`)
            .then((response) => response.json())
            .then((product) => {
              console.log(
                `Product: ${product.product.title}, Tags: ${product.product.tags}`
              ); // ✅ Log tags to console

              // ✅ Convert tags into an array safely
              const productTags =
                typeof product.product.tags === "string"
                  ? product.product.tags.toLowerCase().split(", ")
                  : Array.isArray(product.product.tags)
                  ? product.product.tags.map((tag) => tag.toLowerCase())
                  : [];
              const discountedTags = [
                "acrylic&acrylic",
                "sixbyone",
                "max-up-coat",
              ]; // ✅ Tags to check

              if (productTags.some((tag) => discountedTags.includes(tag))) {
                totalQuantity += item.quantity;
                hasDiscountedProduct = true;
              }
            });
        });

        Promise.all(productChecks).then(() => {
          const freeShippingText =
            document.getElementById("free-shipping-text");
          const progress = document.querySelector(".progress");
          const progressContainer =
            document.getElementById("progress-container");

          // ✅ Hide free shipping bar if no eligible product is in cart
          if (!hasDiscountedProduct) {
            if (freeShippingBar) freeShippingBar.style.display = "none";
            return;
          } else {
            if (freeShippingBar) freeShippingBar.style.display = "block";
          }

          if (progressContainer) {
            progressContainer.style.display = hasDiscountedProduct
              ? "block"
              : "none";
          }

          const progressPercent = (totalQuantity / freeShippingThreshold) * 100;
          progress.style.width = Math.min(progressPercent, 100) + "%";

          const giftCount = getGiftCount(totalQuantity);

          if (totalQuantity >= freeShippingThreshold) {
            freeShippingText.innerText = `🎉 Congratulations! You've qualified for free shipping and received ${giftCount} free gift(s)!`;
          } else {
            const nextThreshold = giftThresholds.find(
              (t) => t.items > totalQuantity
            );
            const itemsNeededForNextGift = nextThreshold
              ? nextThreshold.items - totalQuantity
              : freeShippingThreshold - totalQuantity;

            freeShippingText.innerText = `🎁 You've got ${giftCount} free gift(s)! Add ${itemsNeededForNextGift} more item(s) for the next reward!`;
          }
        });
      })
      .catch((error) => console.error("Error fetching cart data:", error));
  }

  // Call the inner function to update the bar
  updateFreeShippingBar();
}

function initAnnouncementTimer() {
  const announcementSliders = document.querySelectorAll(
    ".announcement-slider__slide"
  );

  announcementSliders.forEach((slide) => {
    const blockId = slide.getAttribute("data-block-id");
    const timerContainer = slide.querySelector(".announcement__timer");

    if (timerContainer) {
      const hours = parseInt(timerContainer.getAttribute("data-hour"), 10) || 0;
      const minutes =
        parseInt(timerContainer.getAttribute("data-minutes"), 10) || 0;

      // Initialize the timer for each slide with the unique block ID and container
      announcementTimer(hours, minutes, blockId, timerContainer);
    }
  });

  function announcementTimer(hours, minutes, id, timerContainer) {
    let startTime = parseInt(
      localStorage.getItem(`announcementStartTime_${id}`),
      10
    );
    if (!startTime) {
      startTime = Date.now();
      localStorage.setItem(`announcementStartTime_${id}`, startTime);
    }
    const totalMilliseconds = hours * 3600000 + minutes * 60000;

    function updateTimerDisplay(remainingMilliseconds) {
      const remainingHours = Math.floor(remainingMilliseconds / 3600000);
      const remainingMinutes = Math.floor(
        (remainingMilliseconds % 3600000) / 60000
      );
      const remainingSeconds = Math.floor(
        (remainingMilliseconds % 60000) / 1000
      );

      const displayHours = String(remainingHours).padStart(2, "0");
      const displayMinutes = String(remainingMinutes).padStart(2, "0");
      const displaySeconds = String(remainingSeconds).padStart(2, "0");

      timerContainer.innerHTML = `<span>${displayHours}</span> : <span>${displayMinutes}</span> : <span>${displaySeconds}</span>`;
    }

    function startInterval() {
      const timerInterval = setInterval(() => {
        const currentTime = Date.now();
        const timeDifference = currentTime - startTime;
        let remainingMilliseconds = totalMilliseconds - timeDifference;

        if (remainingMilliseconds <= 0) {
          clearInterval(timerInterval);
          startTime = Date.now();
          localStorage.setItem(`announcementStartTime_${id}`, startTime);
          remainingMilliseconds = totalMilliseconds;
        }
        updateTimerDisplay(remainingMilliseconds);
      }, 1000);
    }

    startInterval();
  }
}

document.addEventListener("cart:updated", () => {
  clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => {
    updateFreeShipping();
  }, 200);
});

document.addEventListener("DOMContentLoaded", () => {
  updateFreeShipping();
  initAnnouncementTimer();
});
